import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: string, formats = 'dd-MMM-yyyy'): any {
    const datePipe = new DatePipe("en-US");
    if (value && (typeof value == 'string' && value.search(/00/gi) != -1) || !value) {
      return '';
    }
    return datePipe.transform(value, formats);
  }

}